import { PortalErrorStateScheduleEnum } from '../portal-error-state-schedule.enum';

export enum PanelCashOperationsResolverErrorStatesEnum {
  GetPaymentsFailed = PortalErrorStateScheduleEnum.PortalCashOperationsResolverErrorStatesStartIndex,

}
